import { useCallback } from 'react';
import { RangeType } from '../../constants';
import { RangeInputState } from '../../RangeInput/useRangeInput';

export default function useValidatePriceInput(values: RangeInputState) {
  return useCallback(
    (rangeType: RangeType, value: number) => {
      const shouldClearValue = value === 0;
      const isOverCurrentMax = value > (values?.max ?? value);
      const isUnderCurrentMin = value < (values?.min ?? 1);

      const isValidMin = rangeType === RangeType.Min && !isOverCurrentMax;
      const isValidMax = rangeType === RangeType.Max && !isUnderCurrentMin;

      return shouldClearValue || isValidMin || isValidMax;
    },
    [values]
  );
}
